"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feedback = exports.FeedbackStatus = exports.FeedbackSentiment = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const customer_entity_1 = require("../customers/customer.entity");
const user_entity_1 = require("../users/user.entity");
const order_entity_1 = require("../orders/order.entity");
var FeedbackSentiment;
(function (FeedbackSentiment) {
    FeedbackSentiment["POSITIVE"] = "positive";
    FeedbackSentiment["NEGATIVE"] = "negative";
    FeedbackSentiment["NEUTRAL"] = "neutral";
})(FeedbackSentiment || (exports.FeedbackSentiment = FeedbackSentiment = {}));
var FeedbackStatus;
(function (FeedbackStatus) {
    FeedbackStatus["PENDING_FORM"] = "pending_form";
    FeedbackStatus["FORM_SENT"] = "form_sent";
    FeedbackStatus["FORM_FILLED"] = "form_filled";
    FeedbackStatus["FOLLOW_UP_SENT"] = "follow_up_sent";
    FeedbackStatus["VIDEO_REQUESTED"] = "video_requested";
    FeedbackStatus["ESCALATED_MGMT"] = "escalated_to_management";
    FeedbackStatus["CLOSED"] = "closed";
})(FeedbackStatus || (exports.FeedbackStatus = FeedbackStatus = {}));
let Feedback = class Feedback {
};
exports.Feedback = Feedback;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Feedback.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => customer_entity_1.Customer, (c) => c.feedbacks, { onDelete: 'CASCADE' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof customer_entity_1.Customer !== "undefined" && customer_entity_1.Customer) === "function" ? _a : Object)
], Feedback.prototype, "customer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => order_entity_1.Order, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof order_entity_1.Order !== "undefined" && order_entity_1.Order) === "function" ? _b : Object)
], Feedback.prototype, "relatedOrder", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _c : Object)
], Feedback.prototype, "collectedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: FeedbackStatus, default: FeedbackStatus.PENDING_FORM }),
    tslib_1.__metadata("design:type", String)
], Feedback.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: FeedbackSentiment, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Feedback.prototype, "sentiment", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Feedback.prototype, "feedbackText", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'integer', nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Feedback.prototype, "rating", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Feedback.prototype, "formSentAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], Feedback.prototype, "formFilledAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], Feedback.prototype, "followUpSentAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], Feedback.prototype, "videoRequestedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Feedback.prototype, "managementRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Feedback.prototype, "finalRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], Feedback.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_j = typeof Date !== "undefined" && Date) === "function" ? _j : Object)
], Feedback.prototype, "updatedAt", void 0);
exports.Feedback = Feedback = tslib_1.__decorate([
    (0, typeorm_1.Entity)('feedbacks')
], Feedback);
